import { styled } from "baseui";

export const Caption = styled("small", ({ $theme }) => ({
  ...$theme.typography.caption,
  color: $theme.colors.primary500,
}));
